import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import QCSnapTrack from "./QCSnapTrack";
import CommsPage from "./pages/CommsPage";
import StockTakePage from "./pages/StockTakePage";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<QCSnapTrack />} />
        <Route path="/comms" element={<CommsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
        <Route path="/stock" element={<StockTakePage />} />
      </Routes>
    </BrowserRouter>
  );
}